import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import { withResizeDetector } from "react-resize-detector";
import clientPropType from "../../../prop-types/client";
import EventsListContainer from "../../event-list/containers/events-list-container";
import "../styles/events.scss";
import Navigation from "../../navigation/containers/navigation";
import eventType from "../../../prop-types/eventType";
import { updateFilters } from "../../../state/filters/actions";
import {
  fetchGeoLoc,
  userLocationAllowBlock
} from "../../../state/client/actions";
import {
  EVENTS,
  GEO_LOCATION_ERROR_MESSAGE,
  SCHEDULED
} from "../../../constants";
import { getEnabledTabs, getItemFromLS } from "../../../utils/util";

const propTypes = {
  types: PropTypes.arrayOf(eventType).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      tabName: PropTypes.string.isRequired,
      shortName: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  width: PropTypes.number,
  // Match state to props
  client: clientPropType.isRequired,
  filters: PropTypes.shape({
    clientId: PropTypes.number,
    sport: PropTypes.number,
    tabName: PropTypes.string,
    category: PropTypes.number
  }).isRequired,
  // Match dispatch to props
  fetchGeoLocAction: PropTypes.func.isRequired,
  updateLocationDecisionAction: PropTypes.func.isRequired,
  updateFiltersAction: PropTypes.func.isRequired
};

const defaultProps = {
  width: 0
};

function Events(props) {
  const history = useHistory();
  const location = useLocation();
  const {
    client,
    client: {
      features: { geoRestrictEnabled }
    },
    types,
    filters,
    match: {
      params: { shortName, tabName }
    },
    width,
    fetchGeoLocAction,
    updateLocationDecisionAction,
    updateFiltersAction
  } = props;

  useEffect(() => {
    let isLocationExpired = true;
    const lsItem = getItemFromLS("presto_geolocation");
    if (lsItem) {
      const item = JSON.parse(lsItem);
      const expiration = new Date(item?.expiryDate);
      isLocationExpired = new Date().getTime() > expiration.getTime();
    }

    if (geoRestrictEnabled) {
      // Try HTML5 geolocation
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            // isLocationAllowed = true;
            updateLocationDecisionAction(true);
            if (isLocationExpired) {
              fetchGeoLocAction(position);
            }
          },
          // eslint-disable-next-line no-unused-vars
          (err) => {
            // isLocationAllowed = false;
            updateLocationDecisionAction(false);
            toastr.clean();
            toastr.error("", GEO_LOCATION_ERROR_MESSAGE, {
              position: "top-center",
              removeOnHover: false
            });
          }
        );
      } else {
        toastr.clean();
        toastr.error("", "Geolocation is not supported by this browser", {
          position: "bottom-center",
          removeOnHover: false
        });
      }
    }
  }, []);

  useEffect(() => {
    const tabs = getEnabledTabs(client.features);
    if (!tabs.includes(tabName)) {
      // If tab name is not part of "tabs", redirect
      updateFiltersAction({ ...filters, tabName: SCHEDULED });
      history.push(`/${shortName}/${EVENTS}/${SCHEDULED}${location.search}`);
    } else {
      updateFiltersAction({ ...filters, tabName });
    }
  }, [tabName]);

  return (
    <div
      className="events-container d-flex flex-column flex-grow-1 px-0 container-fluid"
      role="region"
    >
      <Navigation types={types} tabName={tabName} />
      <EventsListContainer
        client={client}
        geoRestrictionEnabled={geoRestrictEnabled}
        tabName={tabName}
        width={width}
      />
    </div>
  );
}

Events.propTypes = propTypes;
Events.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  client: state.client.client,
  filters: state.filters.filters
});

const mapDispatchToProps = {
  fetchGeoLocAction: fetchGeoLoc,
  updateLocationDecisionAction: userLocationAllowBlock,
  updateFiltersAction: updateFilters
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withResizeDetector
)(Events);
